export function random() {
	return Math.floor(Math.random() * 1e11).toString(36);
}
